import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Wrench, Workflow, Users } from "lucide-react";

export default function HowWeWork() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16" id="how-we-work">
      <div className="mb-6">
        <Badge className="bg-[hsl(22,100%,50%)]/10 text-[hsl(22,100%,40%)]">🧱 How We Work</Badge>
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight mt-3">A smarter, more transparent way to build</h2>
        <p className="text-muted-foreground mt-2 max-w-prose">
          At Renobuild, we’ve redefined how residential construction should be done. Instead of a large employed team, we manage a network of trusted specialists we’ve worked with for years.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <Card className="bg-white/70 backdrop-blur-md">
          <CardContent className="p-6">
            <h3 className="font-semibold">Why it works</h3>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li>✅ Cost-Effective – Pay only for the trades and materials needed.</li>
              <li>✅ Specialist Quality – Hand-picked people for each stage.</li>
              <li>✅ Full Oversight – We coordinate, schedule, and inspect every step.</li>
              <li>✅ One Point of Contact – We handle comms and building control.</li>
            </ul>
          </CardContent>
        </Card>
        <Card className="bg-white/70 backdrop-blur-md">
          <CardContent className="p-6">
            <h3 className="font-semibold">What you get</h3>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li>Design & planning support (drawings, approvals, advice)</li>
              <li>Transparent quotes with no hidden extras</li>
              <li>Ongoing updates and site reports</li>
              <li>Professional management of every trade and inspection</li>
              <li>Aftercare and snagging support</li>
            </ul>
          </CardContent>
        </Card>
      </div>

      <div className="mt-8 text-sm text-muted-foreground max-w-prose">
        Every project is personally overseen by our experienced team to ensure timelines, budgets, and quality are met — without the overheads or inefficiencies of a traditional building firm.
      </div>
    </section>
  );
}